<div class="modal-content">

    {{ race?.color }}

    <div mat-dialog-title class="d-flex justify-content-between flex-row modal-header align-items-center"
        [ngStyle]="{'background-color': raceColor ?? '#add8e6'}">

        <h3 class="d-flex flex-row align-items-center">
            {{ bib }} - {{ runnerName | titlecase }}
            @if (country) {
            <img [src]="getCountryFlagUrl(country)" [alt]="country" class="country-flag" draggable="false"
                crossorigin="anonymous">
            }
        </h3>

        <button (click)="close()" class="btn btn-light btn-close"></button>

    </div>

    <mat-dialog-content class="modal-body">

        <h4 class="race-name">{{ raceLabel }}</h4>

        <div class="race-time">
            <span class="runner-status">{{ status }} &nbsp;</span>
            @if (isOnRace) { {{ raceDuration }} }
        </div>


        @if (rankings) {
        <hr class="divider-ranks">

        <div class="rankings d-flex flex-row justify-content-around">
            @if (rankings.scratch) {
            <div class="rankingItem text-center d-flex flex-column">
                <span class="rank-label">Scratch</span>
                <span class="rank-number">{{ rankings.scratch }}</span>
            </div>
            }

            @if (rankings.sex) {
            <div class="rankingItem text-center d-flex flex-column">
                <span class="rank-label">Sexe @if(sex) {- {{ sex }}}</span>
                <span class="rank-number">{{ rankings.sex }}</span>
            </div>
            }

            @if (rankings.category) {
            <div class="rankingItem text-center d-flex flex-column">
                <span class="rank-label">Catégorie @if(category) {- {{ category }}}</span>
                <span class="rank-number">{{ rankings.category }}</span>
            </div>
            }
        </div>
        <hr class="divider-ranks">
        }




        <!-- Gestion de la liste des détections -->
        @if (runnerDetections$ | async; as detections) {
        @if (!loadings.detections) {
        <div class="passages">
            <h5 class="text-center">Points de passage</h5>

            @if (detections.length > 0) {
            <table class="tablePassage">
                <thead>
                    <tr class="header-row">
                        <th class="header-cell">Point</th>
                        <th class="header-cell">Heure de passage</th>
                        <th class="header-cell">Temps int.</th>
                        <th class="header-cell">Alt. (m)</th>
                        <th class="header-cell">Dist. (km)</th>
                        <th class="header-cell">D+ (m)</th>
                    </tr>
                </thead>
                <tbody>
                    @for (detection of detections; track detection.cpid; let i = $index) {
                    <tr class="rowtablePassage">
                        <td class="table-cell">{{ detection.pointName }}</td>
                        <td class="table-cell">
                            {{ detection.raceTime | date : 'HH:mm:ss' : event?.timezone?.name }}
                        </td>
                        <td class="table-cell">
                            @if (getDiffTimeFromPrevious(i, detections); as diffTime) {
                            +{{ diffTime }}
                            } @else {
                            <span class="text-muted">-</span>
                            }
                        </td>
                        <td class="table-cell">{{ detection.elevation }}m</td>
                        <td class="table-cell">{{ detection.distanceFromStart }} km</td>
                        <td class="table-cell">+{{ detection.elevationFromStart }}m</td>
                    </tr>
                    }
                </tbody>
            </table>
            } @else {
            <p class="text-center italic">Aucun point de passage enregistré pour le moment.</p>
            }
        </div>
        }
        } @else {
        <p class="text-center">Chargement de vos points de passage...</p>
        }

        <!-- Section Media (Photos / Vidéos) -->
        @if (hasPicture || hasVideos) {
        <mat-tab-group>
            @if (hasPicture) {
            <mat-tab label="Photos">
                <ng-template matTabContent>
                    <div class="pictures">
                        <h5 class="text-center">Photos</h5>
                        <span class="picture-info text-center">Cliquez sur la photo pour la télécharger</span>
                        <div class="pictures-content d-flex flex-row flex-wrap justify-content-around">
                            @for (picture of pictures; track $index) {
                            <img [src]="getPicture(picture.picture)" alt="" class="runner-img" draggable="false"
                                (click)="downloadPicture(picture.picture)">
                            }
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
            }

            @if (hasVideos) {
            <mat-tab label="Vidéos">
                <ng-template matTabContent>
                    <div class="pictures">
                        <h5 class="text-center">Vidéos</h5>
                        <span class="picture-info text-center">Cliquez sur la vidéo pour l'ouvrir</span>
                        <div class="pictures-content d-flex flex-row flex-wrap justify-content-around">
                            @for (video of videos; track $index) {
                            <img [src]="getThumbnailsVideo(video.video)" alt="" class="runner-img" draggable="false"
                                (click)="openDialogVideo(video.video)">
                            }
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
            }
        </mat-tab-group>
        }
    </mat-dialog-content>
</div>

<div mat-dialog-actions></div>